const productType = {
  InitialDRA: 1,
  RepeatedDRA: 2,
  InitialCRALDLP: 3,
  InitialCRAAPOB: 4,
  RepeatedCRALDLP: 5,
  RepeatedCRAAPOB: 6,
  CondensedRepeatedCRAAPOB: 7,
  AdvancedCRAAPOB: 8,
  RepeatedAdvancedCRAAPOB: 9
}

export default productType;